import { drop } from "lodash";

export const api = {
  dashboad: {
    metrics: "/dashboard/stats",
    quick_action_cards: "/dashboard/quick-action-cards",
    inventory_summary_list: "/dashboard/inventory-summary-list",
    order_flow: "/dashboard/order-flow",
    enquiry_summary: "/dashboard/enquiry-summary",
    enquiry_list: "/dashboard/enquiry-summary/list",
    enquiry_dropdown: "/dashboard/enquiry-summary/dropdown",
    quotation_analytics: "/dashboard/quotation-analytics",
    quotation_list: "/dashboard/quotation-analytics/list",
    quotation_dropdown: "/dashboard/quotation-analytics/dropdown",
    inventory_summary_list_filter_dropdown:
      "/dashboard/inventory-summary-list/dropdown",
    order_summary: "/dashboard/order-summary",
    order_dropdown: "/dashboard/order-summary/dropdown",
    order_list: "/dashboard/sales-order-list",
    order_list_dropdown: "/dashboard/sales-order-list/dropdown",
    quotation_order_list: "/dashboard/orders-from-quotation-list",
    direct_order_list: "/dashboard/orders-direct-list",
    total_order_statistics: "/dashboard/order-statistics",
    total_quotation_order_statistics: "/dashboard/orders-from-quotation-count",
    total_direct_order_statistics: "/dashboard/orders-direct-count",
    dispatch_monitoring: "/dashboard/dispatch-monitoring",
    dispatch_monitoring_daily_activity: "/dashboard/dispatch-monitoring/daily-activity",
    daily_order_trend: "/dashboard/daily-order-trend",
    quick_action_card_count: "/dashboard/quick-action/card-count",
    quick_action_low_stock_list: "/dashboard/quick-action/low-stock-alert-list",
    quick_action_low_stock_list_filter_dropdown: "/dashboard/quick-action/low-stock-alert-list/dropdown",
    quick_action_pending_orders_list: "/dashboard/quick-action/order-list",
    quick_action_pending_orders_list_filter_dropdown: "/dashboard/quick-action/order-list/dropdown",
    quick_action_quotation_approval_list: "/dashboard/quick-action/quotation-approval-list",
    quick_action_quotation_approval_list_filter_dropdown: "/dashboard/quick-action/quotation-approval-list/dropdown",
    quick_action_pending_dispatch_list: "/dashboard/quick-action/pending-dispatch-list",
    quick_action_pending_dispatch_list_filter_dropdown: "/dashboard/quick-action/pending-dispatch-list/dropdown",
    revenue_breakdown: "/dashboard/revenue-breakdown",
    revenue_by_delivery_status: "/dashboard/revenue-by-delivery-status",
  },
  master: {
    category: {
      list: "/master/category/",
      dropdown: "/master/category/dropdown",
      fetchCategoryById: "/master/category/",
      fetchCategoryByDropDown: "/master/category/dropdown/",
      updateCategory: "/master/category/update/",
      updateStatusInCategory: "/master/category/update-status/",
      addCategory: "/master/category/create/",
      deleteCategory: "/master/category/delete",
    },
    sub_category: {
      list: "/master/sub-category/",
      fetchSubCategoryById: "/master/sub-category/",
      fetchSubCategoryByDropDown: "/master/sub-category/dropdown/",
      fetchSuCategoryBasedOnSelectedCategory:
        "/master/sub-category/?category_name=",
      fetchSubCategoryByCategoryId: "/master/sub-category/?category_name=",
      updateSubCategory: "/master/sub-category/update/",
      updateStatusInSubCategory: "/master/sub-category/update-status/",
      addSubCategory: "/master/sub-category/create/",
      deleteSubCategory: "/master/sub-category/delete/",
      fetchSubCategoryDropdownByCategoryId:
        "/master/sub-category/dropdown/category",
    },

    item: {
      itemDropdownBySubcategoryId: "/master/item/dropdown/sub-category",
    },
    gst: {
      listing: "",
      dropdown: "/master/gst/dropdown",
    },
    unit: {
      listing: "",
      dropdown: "/master/unit/dropdown",
    },
    warehouse: {
      warehouse_name: "/master/warehouse/dropdown/warehouse_name",
      dropdown: "/master/warehouse/dropdown",
      dropdown_all: "/master/warehouse/dropdown?include_all=true",
      configure_organisation_dropdown: "/organization/all-org/",
      configure_department_dropdown: "/department/by-org/",
      configure_team_dropdown: "/users/teams/by_department",
      configure_user_dropdown: "/users/by_team_id",
    },
    configure_warehouse: {
      list: "/master/configure-warehouse/",
      create: "/master/configure-warehouse/create",
      delete: "/master/configure-warehouse/delete",
    },
    supplier: {
      list: "/master/supplier/",
      supplier_name: "master/supplier/dropdown/supplier_name",
    },
    customer: {
      dropdown: "/master/customer/dropdown",
    },
  },
  site_visit: {
    list: "/site-visit",
    export: "/site-visit/export/",
  },
  order: {
    list: "/order",
    order_by_id: "/order",
    dropdown: "/order",
    create: "/order/create",
    update: "/order/update",
    request_dispatch: "/order/request-dispatch",
    export: "/order/",
    bag: {
      dropdown: "/order/bag/dropdown",
    },
  },
  quotation: {
    list: "/quotation",
    quotation_by_id: "/quotation",
    dropdown: "/quotation",
    enquiry: "/enquiry",
    create: "/quotation/create/",
    update: "/quotation/update",
    export: "/quotation/",
    bag: {
      dropdown: "/quotation/bag/dropdown",
    },
  },
  warehouse: {
    item_inward: {
      sales_item_inword_create:
        "/warehouse/item-inward/sale-order-item-inward/create",
      sales_item_inword_update:
        "/warehouse/item-inward/sale-order-item-inward/update",
      sales_item_inword_revert:
        "/warehouse/item-inward/sale-order-item-inward/revert",
      sales_order_return_listing: "/warehouse/item-inward/sales-order-return",
      sales_order_return_filter_dropdown:
        "/warehouse/item-inward/sales-order-return/dropdown",
      sales_order_return_dispatch_by_id:
        "/warehouse/item-inward/sales-order-return",
      bag_dropdown: "/warehouse/item-inward/bag-no/dropdown",
    },
    warehouse_overview: {
      in_stock: {
        listing: "/warehouse/warehouse-overview/in-stock",
        view_details_listing:
          "/warehouse/warehouse-overview/in-stock/by-item-and-warehouse",
        dropdown: "/warehouse/warehouse-overview/in-stock/dropdown",
      },
      daily_log: {
        listing: "/warehouse/warehouse-overview/daily-log",
        dropdown: "/warehouse/warehouse-overview/daily-log/dropdown",
      },
    },
    dispatch: {
      ready_for_dispatch: {
        listing: "/warehouse/dispatch/ready-for-dispatch",
        create: "/warehouse/dispatch/ready-for-dispatch",
        update: "/warehouse/dispatch/ready-for-dispatch/update-dispatch",
        ready_for_dispatch_by_id: "/warehouse/dispatch/ready-for-dispatch",
        ready_for_dispatch_by_id_for_edit_dispatch:
          "/warehouse/dispatch/ready-for-dispatch",
        export_csv: "/warehouse/dispatch/ready-for-dispatch",
      },
      dispatch_done: {
        listing: "/warehouse/dispatch/dispatch-done",
        update_dispatch_status: "/warehouse/dispatch/dispatch-done",
        sales_order_return:
          "/warehouse/dispatch/dispatch-done/salesorderreturn",
        revert_sales_order_return:
          "/warehouse/dispatch/dispatch-done/revert-salesorderreturn",
        revert: "/warehouse/dispatch/dispatch-revert",
        filter_dorpdown: "/warehouse/dispatch/dispatch-done/dropdown",
        dispatch_by_id: "/warehouse/dispatch/dispatch-done",
        dispatch_by_id_for_view: "/warehouse/dispatch/dispatch-done",
        export_csv: "/warehouse/dispatch/dispatch-done",
      },
      stock_transfer: {
        listing: "/warehouse/dispatch/stock-transfer",
        export_csv: "/warehouse/dispatch/stock-transfer",
        getByID: "/warehouse/dispatch/stock-transfer/",
        get_by_id: "/warehouse/dispatch/stock-transfer/",
        create: "/warehouse/dispatch/stock-transfer/create",
        update: "/warehouse/dispatch/stock-transfer/update/",
        revert: "/warehouse/dispatch/stock-transfer/revert/",
        inventory_item_by_id:
          "/warehouse/dispatch/stock-transfer/inventory-item/",
        dropdown: "/warehouse/dispatch/stock-transfer/dropdown/",
      },
      quotation_dispatch: {
        create: "/quotation",
        update: "/warehouse/dispatch/ready-for-dispatch/update-dispatch",
        quotation_by_id_for_dispatch: "/quotation",
        revert: "/quotation/revert-dispatch",
      },
      issue_to_labour: {
        listing: "/warehouse/dispatch/issue-to-labour",
        getByID: "/warehouse/dispatch/issue-to-labour/",
        create: "warehouse/dispatch/issue-to-labour/create",
        update: "/warehouse/dispatch/issue-to-labour/update/",
        revert: "/warehouse/dispatch/issue-to-labour/",
        inventory_item_by_id:
          "/warehouse/dispatch/stock-transfer/inventory-item/",
        export_csv: "/warehouse/dispatch/stock-transfer",
        dropdown: "/warehouse/dispatch/stock-transfer/dropdown/",
      },
    },
  },
  warehouse2: {
    iteminward: {
      list: "/warehouse/item-inward/",
      create: "/warehouse/item-inward/create/",
      update: "/warehouse/item-inward/update/",
      delete: "/warehouse/item-inward/delete/",
      getGRNByInventoryId: "/warehouse/item-inward/",
      checkEditable: "/warehouse/item-inward/check-editable/",
      checkRevertable: "/warehouse/item-inward/check-revertable/",
      revert: "/warehouse/item-inward/revert/",
      splitBags: "/warehouse/item-inward/split-bags/",
    },
    pendingStockTransfer: {
      list: "/warehouse/item-inward/stock-transfer/pending",
      dropdown: "/warehouse/item-inward/stock-transfer/dropdown/",
      create: "/warehouse/item-inward/stock-transfer/create",
      update: "/warehouse/item-inward/stock-transfer/update/",
      delete: "/warehouse/pending-stock-transfer/delete/",
      details: "/warehouse/item-inward/stock-transfer/",
      revert: "/warehouse/item-inward/stock-transfer/revert/",
    },
    pendingLabourInward: {
      list: "/warehouse/dispatch/issue-to-labour",
      getByID: "/warehouse/dispatch/issue-to-labour/",
      create: "/warehouse/issue-to-labour-inward/create",
      update: "/warehouse/issue-to-labour-inward/update/",
      delete: "/warehouse/pending-labour-inward/delete/",
      details: "/warehouse/pending-labour-inward/",
      revert: "warehouse/issue-to-labour-inward/revert/",
    },
    pendingSalesOrderReturn: {
      list: "/warehouse/pending-sales-order-return/",
      details: "/warehouse/pending-sales-order-return/detail/",
      create: "/warehouse/pending-sales-order-return/create/",
      update: "/warehouse//sale-order-item-inward/update//",
      delete: "/warehouse/pending-sales-order-return/delete/",
    },
  },
  Inventory: {
    InStock: {
      StockOverView: {
        dropdown: "/inventory/in-stock/dropdown",
        export: "/inventory/in-stock/",
      },
    },
    order: {
      list: "inventory/order",
      order_by_id: "inventory/order",
      dropdown: "inventory/order",
      create: "inventory/order/create",
      update: "inventory/order/update",
      request_dispatch: "inventory/order/request-dispatch",
      export: "inventory/order/",
      bag: {
        dropdown: "inventory/order/bag/dropdown",
      },
    },
    dispatch: {
      dispatch_done: {
        listing: "/inventory/dispatch/dispatch-done",
        update_dispatch_status: "/inventory/dispatch/dispatch-done",
        sales_order_return:
          "/inventory/dispatch/dispatch-done/salesorderreturn",
        revert: "/inventory/dispatch/dispatch-revert",
        filter_dorpdown: "/inventory/dispatch/dispatch-done/dropdown",
        dispatch_by_id: "/inventory/dispatch/dispatch-done",
        dispatch_by_id_for_view: "/inventory/dispatch/dispatch-done",
        export_csv: "/inventory/dispatch/dispatch-done",
      },
      stock_transfer: {
        listing: "inventory/dispatch/stock-transfer",
        export_csv: "inventory/dispatch/stock-transfer",
        getByID: "inventory/dispatch/stock-transfer",
        get_by_id: "inventory/dispatch/stock-transfer/",
        create: "inventory/dispatch/stock-transfer/create",
        update: "inventory/dispatch/stock-transfer/update/",
        inventory_item_by_id:
          "inventory/dispatch/stock-transfer/inventory-item/",
        dropdown: "inventory/dispatch/stock-transfer/dropdown/",
      },
      issue_to_labour: {
        listing: "/inventory/dispatch/issue-to-labour",
        getByID: "/inventory/dispatch/issue-to-labour/",
        create: "inventory/dispatch/issue-to-labour/create",
        update: "/inventory/dispatch/issue-to-labour/update/",
        inventory_item_by_id:
          "/inventory/dispatch/issue-to-labour/inventory-item/",
        export_csv: "/inventory/dispatch/issue-to-labour",
        dropdown: "/inventory/dispatch/issue-to-labour/dropdown/",
      },
    },
    Reorderlevel: {
      ItemWise: {
        create: "/inventory/reorderlevel/item-wise/create",
        edit: "/inventory/reorderlevel/item-wise/Update",
        delete: "/inventory/reorderlevel/item-wise/delete",
        listing: "/inventory/reorderlevel/item-wise",
        dropdown: "/inventory/reorderlevel/item-wise/filter-dropdown",
      },
      WarehouseWise: {
        create: "/inventory/reorderlevel/warehouse-wise/create",
        edit: "/inventory/reorderlevel/warehouse-wise/Update",
        delete: "/inventory/reorderlevel/warehouse-wise/delete",
        listing: "/inventory/reorderlevel/warehouse-wise",
        dropdown: "/inventory/reorderlevel/warehouse-wise/dropdown",
      },
    },
  },
};
